export const downloadDocumentAndShare = () => null;
